var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutActive = function SvgLogoutActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C70EE",
    strokeWidth: 2,
    d: "M17 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1C70EE",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M10 12h8.242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C70EE",
    stroke: "#1C70EE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m21 12-4-4v8z"
  })));
};
export { SvgLogoutActive as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTcgNEwxMS4yMjIyIDRMOS4yIDRMNiA0QzQuODk1NDMgNCA0IDQuODk1NDMgNCA2TDQgMThDNCAxOS4xMDQ2IDQuODk1NDMgMjAgNiAyMEwxNyAyMCIgc3Ryb2tlPSIjMUM3MEVFIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBkPSJNMTAgMTJMMTguMjQyMiAxMiIgc3Ryb2tlPSIjMUM3MEVFIiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8cGF0aCBkPSJNMjEgMTJMMTcgOEwxNyAxNkwyMSAxMloiIGZpbGw9IiMxQzcwRUUiIHN0cm9rZT0iIzFDNzBFRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+";